// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bh7N","col":"styles_col__3R5vp"};